import type { MRT_ColumnDef, MRT_RowData } from "mantine-react-table-open";
import { numericFormatter } from "react-number-format";
import { ControlledMantineEditNumberInput } from "../../../../../mantine/mrt/components/edit/ControlledMantineEditNumberInput";
import { HeaderWithHelpIcon } from "../../../../../mantine/mrt/components/header/HeaderWithHelpIcon";
import { isMrtCreating } from "../../../../../mantine/mrt/utils/isMrtCreating";
import { submitOrCancelOnKeyPress } from "../../../../../mantine/mrt/utils/submitOrCancelOnKeyPress";
import type { ValidationErrors } from "../../../../../types/inlineEditTable.types";

const HELP_TEXT = `Der Aufteilungsfaktor muss zwischen 0 und 1 liegen.\n\nAndere Eingaben werden automatisch korrigiert.`;

interface WeightingColumnProps {
  validationErrors: ValidationErrors;
  overrideShareValue?: string;
}

export function getWeightingColumn<T extends MRT_RowData>({
  validationErrors,
  overrideShareValue
}: WeightingColumnProps): MRT_ColumnDef<T> {
  return {
    accessorKey: "weighting",
    header: "Aufteilungsfaktor",
    Header: (
      <HeaderWithHelpIcon headerText="Aufteilungsfaktor" helpText={HELP_TEXT} />
    ),
    enableSorting: true,
    Cell: ({ cell }) => {
      const value = cell.getValue<string | null | undefined>() ?? "";
      return numericFormatter(value, {
        decimalSeparator: ",",
        thousandSeparator: "."
      });
    },
    Edit: ({ cell, column, row, table }) => {
      const shouldOverrideValue = isMrtCreating(table);
      return (
        <ControlledMantineEditNumberInput
          cell={cell}
          columnId={column.id}
          errorText={validationErrors?.weighting}
          label="Aufteilungsfaktor"
          max={1}
          min={0}
          overrideValue={shouldOverrideValue ? overrideShareValue : undefined}
          placeholder="z. B. 0,5"
          row={row}
          onKeyDown={(event) => submitOrCancelOnKeyPress(event, table)}
        />
      );
    }
  };
}
